import { formatDateTimeIntoIsoDate } from "@/composables/formatUtils";
import { goSolidApi } from "@/composables/useGoSolidApi";
import type { BookedCommissions, SalesPartnerRevenue } from "@/types";

export const getBookedCommissions = async (
  referrerIds: number[],
  dateFrom: Date | null,
  dateTo: Date | null
): Promise<BookedCommissions> => {
  const params = new URLSearchParams();
  params.set("referrer_ids", referrerIds.join(","));
  if (dateFrom) {
    params.set("date_from", dateFrom.toISOString());
  }
  if (dateTo) {
    params.set("date_to", dateTo.toISOString());
  }
  const response = await goSolidApi.get(
    `/api/admin/commission/booked?${params.toString()}`
  );
  return response.data.data;
};

/**
 * GET /api/admin/commission/partner-revenue — Soldera's gross and net revenue per sales partner.
 * A sales partner gets only their own row and totals; a full-access admin gets every partner.
 * Dates go as calendar days, as on the financial dashboard, so both pages select the same sales;
 * omitted bounds default to the last 12 months.
 */
export const getSalesPartnerRevenue = async (
  dateFrom: Date | null,
  dateTo: Date | null
): Promise<SalesPartnerRevenue> => {
  const params = new URLSearchParams();
  if (dateFrom) {
    params.set("date_from", formatDateTimeIntoIsoDate(dateFrom));
  }
  if (dateTo) {
    params.set("date_to", formatDateTimeIntoIsoDate(dateTo));
  }
  const response = await goSolidApi.get<SalesPartnerRevenue>(
    `/api/admin/commission/partner-revenue?${params.toString()}`
  );
  return response.data;
};
